module.exports = __webpack_public_path__ + "b730db67797e35d0c4fff69788009f0d.png";